import { data } from 'jquery';
import React,{useState,useEffect,useRef} from 'react'
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods';
import Slider from "react-slick"
import APIUrls from '../../services/APIUrls';
import { handleError } from '../../services/authApiRoutes/APImethods';
import $ from 'jquery'
import icons from '../../icons';

export default function LoginSlider() {
  const sliderRef = useRef(null)
  const [adminSlider, setAdminSlider] = useState([]);
  const settings = {
    autoplay: true,
    accessibility:true,
    adaptiveHeight:false,
    speed: 1000,
    autoplaySpeed: 7000,
    cssEase: "linear",
    dots: true,
    fade: false,
    infinite: true,
    pauseOnDotsHover:true,
    pauseOnFocus:true,
    pauseOnHover:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false
        }
      },
    ]
  };
  
  const indexChange = (e) =>{
    $.each($('.slick-dots li'), function( index, value ) {
      if(! $(value).hasClass("slick-active")){
        $(".slick-dots li button").removeAttr('aria-label');
      }
      $(".slick-dots .slick-active button").attr('aria-label', `Current item ${e+1}`);
  });
    
   
  }
  
  const play = () => {
    sliderRef.current.slickPlay();
  }
  const pause = () => {
    sliderRef.current.slickPause();
  }
  useEffect(() => {
    getAxiosResponse(APIUrls.ADMIN_SLIDER)
      .then((res) => {    
        if (res.data.code === 200) {
         setAdminSlider(res.data.data);
         setTimeout(() => {
          $('.slick-next').attr('aria-label', "Next slide");
          $('.slick-prev').attr('aria-label', "Previous slide"); 
          $.each($('.slick-dots li button'), function( index, value ) {
            $(value).text(`item ${index+1}`);
          });
         }, 300);
 }
      })
      .catch((err) => {
       handleError(err);
      });
      
    },[])

  
  return (
    <div className="slider-content">
      <Slider {...settings} 
      ref={sliderRef}
      afterChange={(e)=>indexChange(e)} 
      >
        {adminSlider.map((slider, index)=>{
          return(
            <div className="slider-item" key={index}>
            <img src ={slider.signedUrl} alt={slider.altText}/>
            </div>
          )
        })}
         
        </Slider>
       {adminSlider.length > 0 ? <div className='flex flex-align play-pause'>
          <button onClick={play} aria-label='Start animation'>
             <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24" fill="#596877">
              <path d="M-838-2232H562v3600H-838z" fill="none"/><path d="M16 10v28l22-14z"/><path d="M0 0h48v48H0z" fill="none"/>
              </svg>
          </button>
          <button onClick={pause} aria-label='Stop animation'>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24" fill="#596877">
            <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"/><path d="M0 0h48v48H0z" fill="none"/>
          </svg>
          </button>
          </div> : ''}
    </div>
  )
}

